"use client"

import { Play, Pause } from "lucide-react"
import { memo } from "react"

type Props = {
  show: boolean
  isPlaying: boolean
  onPlay: (e: React.MouseEvent<HTMLButtonElement>) => void
}

function AlbumPlayButton({ show, isPlaying, onPlay }: Props) {
  return (
    <button
      onClick={onPlay}
      className={`
        absolute inset-0 flex items-center justify-center
        transition
        ${show ? "opacity-100" : "opacity-0 group-hover:opacity-100"}
      `}
    >
      <div className="w-10 h-10 rounded-full bg-black/80 flex items-center justify-center">
        {isPlaying ? (
          <Pause size={16} />
        ) : (
          <Play size={16} />
        )}
      </div>
    </button>
  )
}

export default memo(AlbumPlayButton)